import React from 'react'
import classnames from 'classnames'

interface CarouselDotsProps {
  readonly total: number
  readonly current: number
  onDotClick(index: number): void
}

const CarouselDots: React.FC<CarouselDotsProps> = (props) => {
  const { total, current, onDotClick } = props

  const handleDotClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const index = Number(event.currentTarget.dataset.index)
    if (!isNaN(index)) {
      onDotClick(index)
    }
  }

  const dots: React.ReactNode[] = []

  for (let i = 0; i < total; i++) {
    dots.push(
      <button
        key={i}
        className={classnames(
          'TipsPreview__dot',
          {
            'TipsPreview__dot-active': i === current,
          }
        )}
        onClick={handleDotClick}
        data-index={i}
        type="button"
        aria-label={'Slide ' + (i + 1)}
      />
    )
  }

  return (
    <div className="TipsPreview__dots">
      {dots}
    </div>
  )
}

export default CarouselDots
